/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasParameter } from './OasParameter';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IOasParameterParent {
    /**
     * Gets the parameters.
     * @return {OasParameter[]}
     */
    getParameters() : Array<OasParameter>;

    /**
     * Gets all parameter for a location (path, query, etc).
     * @param {string} in
     * @return {OasParameter[]}
     */
    getParametersIn(__in : string) : Array<OasParameter>;

    /**
     * Adds a parameter.
     * @param {OasParameter} parameter
     * @return {OasParameter}
     */
    addParameter(parameter : OasParameter) : OasParameter;

    /**
     * Creates a parameter.
     * @return {OasParameter}
     */
    createParameter() : OasParameter;

    /**
     * Gets a single parameter by its unique combination of "in" and "name".
     * @param {string} _in
     * @param {string} name
     * @return {OasParameter}
     */
    getParameter(_in : string, name : string) : OasParameter;
}


